import React, { useContext, useEffect, useRef, useState } from 'react';
import PatientCard from './UI/PatientCard/PatientCard';
import a from '../images/1.jpg';
import './../styles/App.css';
import MyModal from './UI/MyModal/MyModal';
import { MainContext } from '..';
import { observer } from 'mobx-react-lite';

const PatientList = observer(({ currentWard }) => {
    const { ws } = useContext(MainContext);
    const { medicalStore } = useContext(MainContext);

    useEffect(() => {
        const connection = async () => {
            await ws.connect();
            await medicalStore.fetchTherapies();
            await medicalStore.fetchIllnessProfiles();
            await medicalStore.fetchPatients();
        };
        connection();
    }, []);

    return (
        <div>
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    justifyContent: '',
                }}
            >
                {medicalStore.therapies
                    .slice(6 * (currentWard - 1), 6 * currentWard)
                    .map((therapy, index) => (
                        <PatientCard
                            key={therapy.id}
                            patientId={therapy.patient}
                            therapyId={therapy.id}
                            bedId={index + 1}
                        />
                    ))}
            </div>
        </div>
    );
});

export default PatientList;

